import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'components/i18n';
import withStyles from 'isomorphic-style-loader/withStyles';
import icons from 'config/icons';
import classNames from 'classnames';

import styles from './showMore.css';

const ShowMoreButton = ({ loading, disabled, onClick }) => (
  <a className={styles.wrapper}>
    <button
      className={styles.button}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={styles.loaderContainer}>
        <span className={loading ? styles.hidden : null}>
          <I18n
            field="show-more"
            defaultText="Show More"
          />
        </span>
        <div className={classNames(styles.imageContainer, {
          [styles.showLoading]: loading,
        })}
        >
          <img
            className={styles.loadingDots}
            src={icons.loadingDots}
            alt="Loading"
            height="8"
            width="32"
          />
        </div>
      </div>
    </button>
  </a>
);

ShowMoreButton.propTypes = {
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ShowMoreButton.defaultProps = {
  disabled: false,
};

export default withStyles(styles)(ShowMoreButton);
